<template>
  <client-only>
    <div
      v-bind="attrs"
      role="status"
      aria-atomic="true"
      :data-open="open"
      :data-error="error"
      class="data-[error=true]:bg-snackbar-red gap-xs right-lg left-lg px-md py-xs motion-safe:transition-bottom fixed -bottom-20 z-100 mx-auto hidden w-fit max-w-[500px] transform items-center bg-gray-800 text-gray-100 transition-discrete duration-300 data-[open=true]:bottom-0 data-[open=true]:flex data-[open=true]:starting:-bottom-20"
    >
      <div :key="uniqId" class="line-clamp-2 wrap-anywhere">
        {{ message }}
      </div>

      <GButton
        v-if="action"
        class="snackbar-action flex-none"
        @click="emit('action')"
      >
        {{ action }}
      </GButton>

      <GButton
        v-if="close"
        class="snackbar-close flex-none"
        aria-label="Fermer notification"
        @click="emit('close')"
      >
        <template #icon>
          <Icon name="fa6-solid:xmark" />
        </template>
      </GButton>
    </div>
  </client-only>
</template>

<script setup>
defineOptions({
  inheritAttrs: false,
});

const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
  error: {
    type: Boolean,
    default: false,
  },
  message: {
    type: String,
    default: "",
  },
  close: {
    type: Boolean,
    default: false,
  },
  action: {
    type: String,
    default: null,
  },
});

const attrs = useAttrs();
const uniqId = ref(0);

watch(
  () => props.open,
  (value) => {
    if (value) {
      setTimeout(() => {
        uniqId.value += 1;
      }, 100);
    }
  },
);

const emit = defineEmits(["action", "close"]);
</script>
